import { render, staticRenderFns } from "./SecaoFacaTeste.vue?vue&type=template&id=71187d83&"
import script from "./SecaoFacaTeste.vue?vue&type=script&async=true&lang=js&"
export * from "./SecaoFacaTeste.vue?vue&type=script&async=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports